import React, {useState} from "react";
import {CustomButton2, CustomIcon, CustomInput, CustomModal, CustomView} from "..";

import "./index.scss";
import api from "../../api";
import successHandler from "../../utils/successHandler";
import errorHandler from "../../utils/errorHandler";

type Props = {
  userId: string;
};

const CustomSubLogin = (props: Props) => {
  const [showModal, setShowModal] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [phoneNumber, setPhoneNumber] = useState<string>("");

  function onValueChangePhoneNumber(event: React.ChangeEvent<HTMLInputElement>) {
    setPhoneNumber(event.target.value);
  }

  async function onSubmitFunction() {
    if (phoneNumber.length < 11) {
      errorHandler(9003);
      return false;
    }
    setIsLoading(!false);
    const resultApi = await api.put.administrator.addSubLogin({_id: props.userId, phoneNumber});
    if (resultApi.CODE === 2012) {
      successHandler(2010);
      setIsLoading(false);
      setShowModal(false);
    } else {
      errorHandler(5099);
      setIsLoading(false);
    }
    return false;
  }

  return (
    <section id="custom-sub-login-content">
      <CustomIcon hoverTitle={"ایجاد ساب لاگ این"} icon="fa-solid fa-user-group" size="medium" onClick={() => setShowModal(!false)} />
      <CustomModal onClose={() => setShowModal(false)} open={showModal} minWidth={"35%"} maxHeight={"9.2rem"} maxWidth={"8rem"}>
        <label>ایجاد ساب لاگ این</label>
        <CustomView.Row className="modal-row-content">
          <CustomView.Column className="modal-colum-content" large={8} medium={12}>
            <CustomInput onValueChange={onValueChangePhoneNumber} value={phoneNumber} placeHolder={"09XX - XXX - XXXX"} />
          </CustomView.Column>
          <CustomView.Column className="modal-colum-content" large={4} medium={12}>
            <CustomButton2 title={"تایید"} type="primary" onClick={onSubmitFunction} isLoading={isLoading} />
          </CustomView.Column>
        </CustomView.Row>
      </CustomModal>
    </section>
  );
};

export default CustomSubLogin;
